import React from 'react'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import FormInput from '../../components/forms/formInput'
import FormSelect from '../../components/forms/formSelect'
import FormTextarea from '../../components/forms/formTextarea'
import GreenButton from '../../components/forms/greenButton'
import FormError from '../../components/forms/formError'
import ApiUrl from '../../configTools/apiUrl'

const Categoryadd = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const navigate = useNavigate();
    const [title,setTitle] = useState('');
    const [type,setType] = useState({name:'C2C/Fashion', value:'1'});
    const [typeList,setTypeList] = useState([]);
    const [slug,setSlug] = useState('');
    const [discription,setDiscription] = useState('');
    const [parent,setParent] = useState({name:'Select', value:'0'});
    const [parentList,setParentList] = useState([]);
    const [parenttypefilterList,setParentTypeFilterList] = useState([]);
    const [error,setError] = useState("");

    const changeType = (e)=>{
        let filterVal = [{name:'None', value:'0'}];
        for (let index = 0; index < parentList.length; index++) {
            const element = parentList[index];
            if(element.type === parseInt(e.value)){
                filterVal.push({
                    name : element.title,
                    value : String(element.id)
                })
            }
        }
        setParentTypeFilterList(filterVal);
        setType(e);
    }
    
    const get_admin_select = () =>{
        fetch(ApiUrl.API_URL_Collection)
        .then(res=>res.json())
        .then(data =>{
            let allparents = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if(element.parentid === 0){
                    allparents.push(element);
                }
            }
            setParentList(allparents);
            let filterVal = [{name:'None', value:'0'}];
            for (let index = 0; index < allparents.length; index++) {
                const element = allparents[index];
                if(element.type === 1){
                    filterVal.push({
                        name : element.title,
                        value : String(element.id)
                    })
                }
            }
            setParentTypeFilterList(filterVal);
        });
    }
    useEffect(() => {
        setTypeList([
            {name:'C2C/Fashion', value:'1'},
            {name:'Art', value:'2'},
            {name:'Wholesale', value:'3'}
        ])
        get_admin_select();
    },[])
    function add_admin(){
        fetch(ApiUrl.API_URL_Collection, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            },
            body: JSON.stringify({
                title : title,
                slug : slug,
                discription : discription,
                parentid : parseInt(parent.value),
                type : parseInt(type.value)
            })
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.success){
                navigate('/admin/products/category/edit/'+data.id);
            }
            else{
                setError(data.responce);
            }
        });
    }

  return (
    <div className='admin_forms_main_container'>
      <div className='admin_forms_row'>
        <div className='admin_col_50'></div>
        <div className='admin_col_50'>
            <div className='admin_forms_container'>
                <FormError Value={error}/>
                <FormInput Lable='Title' Type='text' Placeholder='Enter name' Value={title} setValue={setTitle}/>
                <FormSelect Lable='Type' Value={type} setValue={changeType} Options={typeList}/>
                <FormInput Lable='Slug' Type='text' Placeholder='Enter slug' Value={slug} setValue={setSlug}/>
                <FormSelect Lable='Parent' Value={parent} setValue={setParent} Options={parenttypefilterList}/>
                <FormTextarea Lable='Discription' Placeholder='Enter discription' Value={discription} setValue={setDiscription}/>
                <GreenButton Value='Save' Action={add_admin}/>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Categoryadd
